import { gql, useLazyQuery } from '@apollo/client';
import React, { useState } from 'react';

import {
	LegacyAutocomplete as Autocomplete,
	LegacyAutocompleteInput as AutocompleteInput,
	LegacyAutocompleteOptions as AutocompleteOptions,
} from '@flixbus/honeycomb-react';

const SEARCH_MOBILITY_PARTNERS = gql`
	query searchMobilityPartnersByShortName($shortName: String!) {
		searchMobilityPartnersByShortName(shortName: $shortName) {
			id
			shortName
		}
	}
`;

const MobilityPartnerField = ({ fieldControl, submitOnChange }) => {
	const [getMobilityPartners, { loading, error, data }] = useLazyQuery(SEARCH_MOBILITY_PARTNERS);
	const [isDebounceTriggered, setDebounceTriggered] = useState(false);
	const onDebounce = (e) => {
		if (!e.target.value) return;
		getMobilityPartners({ variables: { shortName: e.target.value } });
		setDebounceTriggered(true);
	};

	const onSelect = (item) => {
		fieldControl.onChange(item);
		submitOnChange();
		setDebounceTriggered(false);
	};

	const getData = () => {
		return data?.searchMobilityPartnersByShortName.map((partner) => ({
			title: partner.shortName,
			key: partner.id,
		}));
	};

	const readyToShow = () => {
		const isQueryOk = !loading && !error;
		return !!(isQueryOk && isDebounceTriggered);
	};

	const getOptions = () => {
		return readyToShow() ? getData() : [];
	};

	const checkEmpty = (e) => {
		if (e.target.value === '') {
			// resubmit("cityId");
			fieldControl.onChange('');
			submitOnChange();
		}
	};
	return (
		<Autocomplete
			onDebounce={(e) => onDebounce(e)}
			value={fieldControl.value.title}
			onSelect={(item) => onSelect(item)}
			options={getOptions()}
			onChange={checkEmpty}
		>
			<AutocompleteInput
				id="crewManagement-search-mobilePartner"
				type="search"
				label="Mobility partner"
				placeholder="e.g Best Partner"
				loading={loading}
			/>
			<AutocompleteOptions optionsToDisplay={5} label="partners" />
		</Autocomplete>
	);
};

export default MobilityPartnerField;
